import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { authRequest } from '../../../../../common/request/authRequest';
import { Modal, message } from 'antd';
import { MapCompetitors } from '../_common/MapCompetitors';
import { InfoCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { DrawerPanelTitle, modalPanelStyles } from '../../../common/Drawers/DrawerPanelTitle';

export const CompetitorsMapModal = (props: {geogridId: string, onClose: any }) => {
    
    const [geoGrid, setGeoGrid] = useState<any>(null);    
    const { logOut, projectGroup } = useAuth();

    useEffect(() => {
        
        authRequest(
          `${process.env.REACT_APP_API}/projects/${projectGroup.project}/geogrid/${props.geogridId}`,
            { method: 'GET' }
            )
            .then((data) => {
               
                setGeoGrid(data);                
            })
            .catch((error) => {
                if (error && error.status === 401) {
                    if (error.data.message === 'Google') {
                      //history.push('/vincular', { from: location });
                    } else {
                        message.error('Token expirado')
                        logOut();
                    }
                }
            });            
        }, []);              

    return (        
        <Modal
            open={true}
            onCancel={props.onClose}
            width={'60%'}
            footer={null}
            style={{ top: 20 }}
            {...modalPanelStyles}
            title={
                <DrawerPanelTitle
                    title={
                        geoGrid
                            ? <>Alcance de <b>{geoGrid.localPackMaxDistance.toFixed(0)} mts.</b> de visibilidad para <b>"{geoGrid.text}"</b></>
                            : 'Alcance de visibilidad'
                    }
                />
            }
        >                        
            <p><InfoCircleOutlined/> El cuadro blanco marca la zona de grid analizada: <b>{geoGrid ? `${2 * geoGrid.radiusParts + 1}x${2 * geoGrid.radiusParts + 1} puntos; ${geoGrid.radius}` : '…'}</b> metros alrededor de nuestro negocio</p>
 
            <div style={{ width: '100%', height: '600px', borderRadius: '25px', overflow: 'hidden', position: 'relative' }}>                            
                {geoGrid && <MapCompetitors geogrid={geoGrid}/>}            
            </div>
        </Modal>
    );
}
